import * as React from 'react'
import { AppMenuIcon } from '$views/components/AppMenu/components/AppMenuIcon'
import { WrapperMenu, ContainerMenu, WrapperAppMenu } from '$views/components/AppMenu/AppMenu.style'
import { AppMenuCustomer, AppMenuCaretaker } from '$views/components/AppMenu/AppMenu.model'
import { userGroupService } from '$utils/services/userGroupService'
import history from '$utils/history'
import { routeProvider } from '$utils/routeProvider'
import { DeepLinkApp } from '$views/components/AppMenu/components/DeepLinkApp'
import { useUnreadMessages } from '$utils/hooks/useUnreadMessages'

const documentIcon = require('$icons/documentApp.svg')
const documentGreyIcon = require('$icons/documentAppGrey.svg')
const chatIcon = require('$icons/chat.svg')
const chatGreyIcon = require('$icons/chatGrey.svg')
const homeIcon = require('$icons/home.svg')
const homeGreyIcon = require('$icons/homeGrey.svg')
const optionsIcon = require('$icons/options.svg')
const optionsGreyIcon = require('$icons/optionsGrey.svg')
const profileIcon = require('$icons/profile.svg')
const profileGreyIcon = require('$icons/profileGrey.svg')
const searchIcon = require('$icons/searchApp.svg')
const searchGreyIcon = require('$icons/searchAppGrey.svg')

interface Props {
  optionSelected: string
  hideDeepLink?: boolean
}

export const AppMenu: React.FC<Props> = ({ optionSelected, hideDeepLink }) => {
  const [caretakerOption, setCaretakerOption] = React.useState<string>(AppMenuCaretaker.services)
  const [customerOption, setCustomerOption] = React.useState<string>(AppMenuCustomer.home)
  const [isCaretaker] = React.useState<boolean>(userGroupService.isCaretaker())

  React.useEffect(() => {
    if (userGroupService.isCaretaker()) {
      setCaretakerOption(optionSelected)
    } else {
      setCustomerOption(optionSelected)
    }
  })

  const isEnableToCaretaker = (step: string) => {
    if (caretakerOption === step) {
      return true
    }
    return false
  }

  const isEnableToCustomer = (step: string) => {
    if (customerOption === step) {
      return true
    }
    return false
  }

  if (!isCaretaker) {
    return (
      <>
        <WrapperMenu>
          {!hideDeepLink && <DeepLinkApp />}
          <WrapperAppMenu>
            <ContainerMenu>
              <AppMenuIcon
                content={isEnableToCustomer(AppMenuCustomer.home) ? homeIcon : homeGreyIcon}
                onClick={() => history.push(routeProvider.myUserArea)}
                label="Inicio"
                isEnable={isEnableToCustomer(AppMenuCustomer.home)}
              />
              <AppMenuIcon
                content={isEnableToCustomer(AppMenuCustomer.services) ? documentIcon : documentGreyIcon}
                onClick={() => history.push(routeProvider.myServices)}
                label="Mis servicios"
                isEnable={isEnableToCustomer(AppMenuCustomer.services)}
              />
              <AppMenuIcon
                content={isEnableToCustomer(AppMenuCustomer.search) ? searchIcon : searchGreyIcon}
                onClick={() => history.push(routeProvider.caretakerList)}
                label="Buscar"
                isEnable={isEnableToCustomer(AppMenuCustomer.search)}
              />
              <AppMenuIcon
                content={isEnableToCustomer(AppMenuCustomer.chat) ? chatIcon : chatGreyIcon}
                onClick={() => history.push(routeProvider.chat)}
                label="Chat"
                circle={useUnreadMessages()}
                isEnable={isEnableToCustomer(AppMenuCustomer.chat)}
              />
              <AppMenuIcon
                content={isEnableToCustomer(AppMenuCustomer.options) ? optionsIcon : optionsGreyIcon}
                onClick={() => history.push(routeProvider.settings)}
                label="Más"
                isEnable={isEnableToCustomer(AppMenuCustomer.options)}
              />
            </ContainerMenu>
          </WrapperAppMenu>
        </WrapperMenu>
      </>
    )
  }

  return (
    <WrapperMenu>
      {!hideDeepLink && <DeepLinkApp />}
      <WrapperAppMenu>
        <ContainerMenu>
          <AppMenuIcon
            content={isEnableToCaretaker(AppMenuCaretaker.offers) ? searchIcon : searchGreyIcon}
            onClick={() => history.push(routeProvider.offersForCaretaker)}
            label="Ofertas"
            isEnable={isEnableToCaretaker(AppMenuCaretaker.offers)}
          />
          <AppMenuIcon
            content={isEnableToCaretaker(AppMenuCaretaker.services) ? documentIcon : documentGreyIcon}
            onClick={() => history.push(routeProvider.myServices)}
            label="Mis servicios"
            isEnable={isEnableToCaretaker(AppMenuCaretaker.services)}
          />
          <AppMenuIcon
            content={isEnableToCaretaker(AppMenuCaretaker.chat) ? chatIcon : chatGreyIcon}
            onClick={() => history.push(routeProvider.chat)}
            label="Chat"
            circle={useUnreadMessages()}
            isEnable={isEnableToCaretaker(AppMenuCaretaker.chat)}
          />
          <AppMenuIcon
            content={isEnableToCaretaker(AppMenuCaretaker.profile) ? profileIcon : profileGreyIcon}
            onClick={() => history.push(routeProvider.profile)}
            label="Perfil"
            isEnable={isEnableToCaretaker(AppMenuCaretaker.profile)}
          />
          <AppMenuIcon
            content={isEnableToCaretaker(AppMenuCaretaker.options) ? optionsIcon : optionsGreyIcon}
            onClick={() => history.push(routeProvider.settings)}
            label="Más"
            isEnable={isEnableToCaretaker(AppMenuCaretaker.options)}
          />
        </ContainerMenu>
      </WrapperAppMenu>
    </WrapperMenu>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/AppMenu/AppMenu.tsx